export const isCognitoEnabled = import.meta.env.VITE_IDP_COGNITO_ENABLED === 'true';
export const isNativeCognitoEnabled =
  isCognitoEnabled && import.meta.env.VITE_IDP_COGNITO_NATIVE_ENABLED === 'true';
